import { Injectable } from '@angular/core';
import { AbstractControl, UntypedFormArray, ValidationErrors } from '@angular/forms';
import { DialogService } from '@shared/dialog/services/dialog.service';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { MyDeviceFormRemote } from './my-device-form.remote';
import { DeviceUser } from '@core/models/device-user';
import { UserDevicesFormValidationErrorKye } from '../models/user-devices-form-validation-error-key.enum';

@Injectable({
  providedIn: 'any'
})
export class MyDeviceFormService {
  constructor(
    private myDeviceFormRemote: MyDeviceFormRemote,
    private dialogService: DialogService
  ) {}

  checkSerial(params: {
    serial: string;
    passphrase?: string;
  }): Observable<ValidationErrors | null> {
    return this.myDeviceFormRemote.checkSerial(params).pipe(
      map((response) => {
        // serial is valid
        if (!response.valid) {
          return { [UserDevicesFormValidationErrorKye.INVALID]: 'invalid' };
        }

        // serial is not disabled
        if (response.disabled) {
          return { [UserDevicesFormValidationErrorKye.DISABLED]: true };
        }

        // serial passphrase is correct
        if (response.passphrase !== undefined) {
          return response.passphrase
            ? null
            : { [UserDevicesFormValidationErrorKye.INCORRECT_SERIAL_PASSPHRASE]: 'passphrase' };
        }

        // serial is free
        if (!response.free) {
          return { [UserDevicesFormValidationErrorKye.NOT_FREE]: 'notfree' };
        }

        return null;
      })
    );
  }

  openDistributorsInfo(): void {
    this.dialogService.openDialog({
      panelClass: 'custom-dialog-my-device-form',
      width: '75w',
      minHeight: '325px',
      title: 'home.header.distributors',
      message: [
        'captive.form.my-device.modal-distributors',
        'captive.form.my-device.modal-distributors-2'
      ]
    });
  }

  openSharedDeviceInfo(): void {
    this.dialogService.openDialog({
      panelClass: 'custom-dialog-my-device-form',
      width: '75w',
      minHeight: '325px',
      title: 'dialog.shared-device.title',
      message: ['dialog.shared-device.info']
    });
  }

  openSerialInfo(): void {
    this.dialogService.openDialog({
      panelClass: 'custom-dialog-my-device-form',
      width: '75w',
      minHeight: '325px',
      title: 'dialog.serial-number.serial',
      message: ['dialog.serial-number.info1']
    });
  }

  unlinkDevice(userId: number, device: DeviceUser) {
    return this.myDeviceFormRemote.unlinkSerial(userId, device);
  }

  openImageFirmwareInfo(imagePath: string): void {
    this.dialogService.openDialog({
      panelClass: 'custom-dialog-my-device-form',
      width: '75w',
      image: {
        href: imagePath,
        alt: 'dialog.firmware-image.alt'
      }
    });
  }
}
